import { ContentPublicRelayDto } from '@diritto/common/relay/dtos/content-relay.dtos';
import styled from '@emotion/styled';
import { ContentDetailEventItem } from 'app-components/contents/detail/ContentDetailEventItem';
import { ContentDetailNoticeItem } from 'app-components/contents/detail/ContentDetailNoticeItem';
import { useGetContentEventsQuery } from 'queries/contents/useGetContentEventsQuery';
import React, { useMemo } from 'react';
import { useGetRelayContentNoticesQuery } from 'queries/relay/useGetContentNoticesQuery';
import { AgeRestriction } from '@diritto/common/content/constants';

interface ContentDetailEpisodeListProps {
  content: ContentPublicRelayDto;
}

export const ContentDetailNoticeList = ({ content }: ContentDetailEpisodeListProps) => {
  const { data: noticeData } = useGetRelayContentNoticesQuery({ contentId: content.id });
  const { noticeIds, noticeEpisodes } = useMemo(
    () => ({
      noticeIds: noticeData?.episodeIds || [],
      noticeEpisodes: noticeData?.episodes || {},
    }),
    [noticeData],
  );

  const { data: contentEventsData } = useGetContentEventsQuery(content.id);
  const events = contentEventsData?.events ?? [];

  if (events.length === 0 && noticeIds.length === 0) {
    return null;
  }

  return (
    <StyledContainer>
      {noticeIds.map(it => {
        const episode = noticeEpisodes[it];
        return (
          episode && (
            <li key={`notice-item-${episode.id}`}>
              <ContentDetailNoticeItem
                episode={episode}
                isAdultContent={content.ageRestriction === AgeRestriction.Adult}
              />
            </li>
          )
        );
      })}
      {events.map(it => (
        <li key={`event-item-${it.id}`}>
          <ContentDetailEventItem event={it} />
        </li>
      ))}
    </StyledContainer>
  );
};
const StyledContainer = styled.ul`
  margin-top: 16px;
`;
